import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';

export const ULStyled = styled.ul`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      column-count: ${mediumUp ? 2 : 1};
      list-style: none;
      padding: 0;
    `;
  }
}`;

export const LIStyled = styled.li`
  ${({ theme }) => {
    const largeUp = theme.largeUp();
    const mediumUp = theme.mediumUp();

    let thisHorizontalPadding = 0;

    if(largeUp){
      thisHorizontalPadding = rem(70);
    } else if(mediumUp){
      thisHorizontalPadding = rem(10);
    }

    return css`
      padding: 0 ${thisHorizontalPadding};
      ::after {
        content: '';
        display: block;
        width: 100%;
        margin: ${rem(20)} 0;
        height: ${rem(1)};
        background-color: ${theme.colors.brand.pcg.gold1};
        background: linear-gradient(90deg, ${theme.colors.brand.pcg.gold1} 0%, ${theme.colors.brand.pcg.gold2} 50%, ${theme.colors.brand.pcg.gold1} 100%);
      }
    `;
  }
}`;
